const UTMIFY_PIXEL_ID = '';

/**
 * Loads the official UTMify tracking scripts (UTM parameter tracker + pixel).
 * Safe to call multiple times — scripts are only injected once.
 */
export function loadUtmify(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  // --- UTMify UTM parameter tracking script ---
  if (!document.querySelector('script[data-utmify-utms]')) {
    const utmScript = document.createElement('script');
    utmScript.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
    utmScript.async = true;
    utmScript.defer = true;
    utmScript.setAttribute('data-utmify-prevent-xcod-sck', '');
    utmScript.setAttribute('data-utmify-prevent-subids', '');
    utmScript.setAttribute('data-utmify-utms', 'true');
    document.head.appendChild(utmScript);
  }

  // --- UTMify pixel script ---
  if (UTMIFY_PIXEL_ID && !document.querySelector('script[data-utmify-pixel]')) {
    (window as unknown as Record<string, unknown>).pixelId = UTMIFY_PIXEL_ID;
    const pixelScript = document.createElement('script');
    pixelScript.src = 'https://cdn.utmify.com.br/scripts/pixel/pixel.js';
    pixelScript.async = true;
    pixelScript.defer = true;
    pixelScript.setAttribute('data-utmify-pixel', 'true');
    document.head.appendChild(pixelScript);
  }
}
